<template>
  <modal-gestor :opened="true" no-pad="true" width="medium">
    <div class="pedido-preview-header border-bottom shadow-sm">
      <button aria-label="Voltar" class="btn btn-outline-dark" style="width: 42px; font-size: 18px" title="Voltar" type="button" @click="$emit('voltar')">
        <i aria-hidden="true" class="fa fa-chevron-left"></i>
      </button>
    </div>
    <div class="pedido-preview-body p-3">
      <loading v-if="carregando"/>
      <div v-else-if="erro" class="alert alert-warning mb-0" role="alert">{{ erro }}</div>
      <cupom-delivery v-else-if="pedido" id="pedidoPreview" :preview="false" :selecionado="pedido"/>
    </div>
  </modal-gestor>
</template>

<script>
import ModalGestor from './ModalGestor';
import CupomDelivery from './CupomDelivery';
import Loading from '@/components/commons/Loading';

export default {
  name: 'ModalPedidoPreview',
  components: { ModalGestor, CupomDelivery, Loading },
  props: {
    pedidoId: { type: [Number, String], required: true }
  },
  data() {
    return { carregando: true, pedido: null, erro: '' };
  },
  mounted() {
    const token = localStorage.getItem('key');
    this.$http.get(`delivery/pedidos/${token}/${this.pedidoId}`).then(res => {
      if (this._isDestroyed) return;
      this.carregando = false;
      if (res.data && res.data.id_pedido && res.data.cliente) {
        this.pedido = res.data;
      } else {
        this.erro = 'Pedido não encontrado.';
      }
    }, res => {
      if (this._isDestroyed) return;
      this.carregando = false;
      this.erro = 'Não foi possível carregar o pedido. Volte e tente novamente.';
      if (res.status === 401) this.logout(true);
    });
  }
};
</script>

<style scoped>
.pedido-preview-header {
  padding: 6px 15px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pedido-preview-body { height: calc(100vh - 130px); overflow: auto; }
@media (max-width: 768px) {
  .pedido-preview-body { height: calc(100vh - 113px); }
}
</style>
